import { getNodeByTreePath } from 'anodum';
import getAdvancedSelection from '../../text-formatting/accessors/get-advanced-selection';
import view from '../../view';

const setSelectionByNodePath = (element, selectionData) => {
  const { anchor, focus, isBackwards } = selectionData;
  const selection = getAdvancedSelection();
  const liveDocument = view.accessors.getLiveDocument();
  const range = liveDocument.createRange();

  const focusNode = getNodeByTreePath(element, focus.path);
  const anchorNode = getNodeByTreePath(element, anchor.path);

  try {
    if (isBackwards) {
      range.setStart(focusNode, focus.offset);
      range.setEnd(anchorNode, anchor.offset);
    } else {
      range.setStart(anchorNode, anchor.offset);
      range.setEnd(focusNode, focus.offset);
    }

    selection.removeAllRanges();
    selection.addRange(range);
    selection.refresh();
  } catch (error) {
    console.error(error);
  }

  return selection;
};

export default setSelectionByNodePath;
